
import { VList } from "vuetify/lib";

export default VList.extend({});
